__turbopack_context__.v({
  "className": "cormorant_garamond_2cc5ce3a-module___tt0Fq__className",
});
